import Glide from '@glidejs/glide';
import '../../../../shared/js/utils/polyfills';

export function initGiftCarousels(scope) {
    const scopePrefix = typeof scope === 'undefined' ? '' : scope + ' ';

    const carouselsGifts = document.querySelectorAll(scopePrefix + '.product-slider-gifts');

    // inicializace slideru "darky"
    if (carouselsGifts) {
        carouselsGifts.forEach((element) => {
            const slidesPhysicalCount = element.querySelectorAll('.glide__slide').length;

            const perViewHandled = (items) => (items <= slidesPhysicalCount ? items : slidesPhysicalCount);

            const toggleArrows = () => {
                if (productSlider.settings.perView < slidesPhysicalCount) {
                    element.querySelector('.product-slider .product-slider__arrows').classList.remove('d-none');
                } else {
                    element.querySelector('.product-slider .product-slider__arrows').classList.add('d-none');
                }
            };

            // eslint-disable-next-line no-unused-vars
            const isDragable = () => {};

            const productSlider = new Glide(element, {
                autoplay: false,
                perView: perViewHandled(2),
                breakpoints: {
                    880: {
                        perView: 1,
                    },
                    768: {
                        perView: 2,
                    },
                },
                type: 'carousel',
                gap: 0,
            });

            productSlider.on(['resize', 'mount.before'], () => {
                toggleArrows();
            });

            productSlider.mount();

            naja.uiHandler.bindUI(element);
        });
    }
}
